// Localização: frontend/src/components/Layout/Title.js (Versão 1.0.0)

import React from 'react';

/**
 * Componente simples para renderizar o título principal das páginas.
 * Usa o estilo consistente do Tailwind CSS (grande, negrito, cor teal).
 * @param {string} children - O texto do título.
 * @param {string} className - Classes adicionais para customização.
 */
const Title = ({ children, className = '' }) => {
    return (
        <h1 
            className={`text-3xl font-bold text-teal-700 border-b border-gray-200 pb-3 mb-6 ${className}`}
        >
            {children}
        </h1>
    );
};

export default Title;